import { ToolEditorProvider } from "components/ToolEditor/Provider/ToolEditorProvider";
import { ToolEditorForm } from "./Form/ToolEditorForm";

export interface ToolEditorProps {
  toolVersionId: number;
  resetDataTableProviderKey: () => void;
  setTableKey: (key: string | undefined) => void;
}
export const ToolEditor = ({
  toolVersionId,
  resetDataTableProviderKey,
  setTableKey,
}: ToolEditorProps) => {
  return (
    <ToolEditorProvider
      toolVersionId={toolVersionId}
      resetDataTableProviderKey={resetDataTableProviderKey}
      setTableKey={setTableKey}
    >
      <ToolEditorForm />
    </ToolEditorProvider>
  );
};
